/**
 * AdminToaster.jsx - Toast notifications for Admin panels
 * 
 * Provides honest feedback for save actions:
 * - Success: shown only when save truly succeeded
 * - Error: shown when save fails with actual error message
 * - Info: used for local-only or backend-dependent actions
 */

import { Toaster as SonnerToaster, toast } from 'sonner';
import { theme } from '../../data/colors';

// Custom styled Toaster for admin panel (dark theme)
export function AdminToaster() {
  return (
    <SonnerToaster
      position="top-right"
      expand={false}
      richColors
      closeButton
      toastOptions={{
        style: {
          background: theme.bgToast,
          border: '1px solid #333',
          color: theme.textInverse,
        },
        classNames: {
          success: 'toast-success',
          error: 'toast-error',
          info: 'toast-info',
        },
      }}
    />
  );
}

// Export toast directly for use in components
export { toast };

// Helper functions for consistent messaging
export const showSaveSuccess = (message = 'Changes saved successfully') => {
  toast.success(message, {
    duration: 3000,
  });
};

export const showSaveError = (message = 'Failed to save changes') => {
  toast.error(message, {
    duration: 5000,
  });
};

export const showLocalOnlyInfo = (message = 'Saved to this device only') => {
  toast.info(message, {
    description: 'This data is stored locally and will not sync to the server.',
    duration: 4000,
  });
};

export const showBackendDependentInfo = (featureName = 'This feature') => {
  toast.info(`${featureName} - UI Preview Only`, {
    description: 'Backend integration pending. Changes are not persisted.',
    duration: 4000,
  });
};
